// src/api/rbacApi.ts
import request from '@/utils/request';

/**
 * 权限api模块
 */
export const rbacApi = {

    /**
     * 获取权限列表-分页
     */
    getPermissionPageList: (requestData: any) => {
        return request.post('/api/rbac/permission/page', requestData)
    },
    /**
     * 获取父级权限列表
     */
    getAllPermissionList() {
        return request.get('/api/rbac/permission/parent/list')
    },
    /**
     * 获取所有权限树列表
     */
    getAllPermissionTree() {
        return request.get('/api/rbac/permission/tree/all/list')
    },
    /**
     * 新增权限
     */
    addPermission: (requestData: any) => {
        return request.post('/api/rbac/permission/add', requestData)
    },
    /**
     * 修改权限
     */
    editPermission: (requestData: any) => {
        return request.post('/api/rbac/permission/update', requestData)
    },
    /**
     * 根据角色ids获取权限树
     */
    getPermissionByRoleIds: (requestData: any) => {
        return request.post('/api/rbac/permission/tree/by/roleIds', requestData)
    },
    /**
     * 根据角色id获取该角色权限树
     */
    getPermissionByRoleId(requestData: any) {
        return request.get('/api/rbac/permission/tree/by/roleId', requestData)
    },
    /**
     * 根据角色id获取权限ids
     */
    getPermIdsByRoleId(requestData: any) {
        return request.get('/api/rbac/permIds/by/roleId', requestData)
    },
    /**
     * 批量删除权限
     */
    handleBatchDeletePerm(requestData: any) {
        return request.post('/api/rbac/permission/delete/batch', requestData)
    },
    /**
     * 批量启用或禁用权限
     */
    batchUpdatePermStatus(requestData: any) {
        return request.post('/api/rbac/permission/disable-or-enable/batch', requestData)
    },


    /**
     * 获取角色列表
     */
    getRoleList(requestData: any) {
        return request.get('/api/rbac/role/list', requestData)
    },
    /**
     * 新增角色
     */
    addRole(requestData: any) {
        return request.post('/api/rbac/role/add', requestData)
    },
    /**
     * 修改角色
     */
    updateRole(requestData: any) {
        return request.post('/api/rbac/role/update', requestData)
    },
    /**
     * 批量删除角色
     */
    handleBatchDeleteRole(requestData: number[]) {
        return request.post('/api/rbac/role/delete/batch', requestData)
    },
    /**
     * 获取角色列表 - 分页
     */
    getRolePageList(requestData: any) {
        return request.post('/api/rbac/role/page', requestData)
    },
    /**
     * 批量启用或禁用角色
     */
    batchUpdateRoleStatus(requestData: any) {
        return request.post('/api/rbac/role/disable-or-enable/batch', requestData)
    },
};
